// SPEC-SW-PRECACHE-HASH-CHAIN-FIX-V1 (D-606) ITEM_2/ITEM_3:
//   ビルド時刻を「ビルド時定数」から「実行時に version.json から読む値」へ移す。
//   ★理由(D-605-DIAG の実測): __BUILD_TIME__ を焼き込むと、それを持つ index-*.js の
//     ハッシュが毎ビルド変わり、import している 159 チャンクへ連鎖して
//     220 件中 162 件が別名になっていた(中身は 159 件が完全同一)。
//     workbox の precache install は直列なので「件数 × レイテンシ」が所要時間になり、
//     コードを 1 行も変えなくても毎デプロイ約 163 件 / 2.6MiB を取り直していた。
//   ★version.json は D-456 で precache 対象外 + no-store なので常に最新が取れる。
//   ★取得は既存の fetchRemoteVersion を使う(自前で fetch を書き直さない=経路を 2 本にしない。
//     D-215/D-597 の屍: 同じ目的の経路が 2 つあると片方が壊れたまま長期化する)。
import { useEffect, useState } from 'react'
import { fetchRemoteVersion } from '../lib/swRegistration'

/**
 * version.json の build_time を返す。取得前と取得失敗時は null。
 * ★best-effort。投げない。画面はこの値が無くても成立する(呼び出し側が時刻抜きで出す)。
 */
export function useBuildTime({ fetchFn = fetchRemoteVersion } = {}) {
  const [buildTime, setBuildTime] = useState(null)
  useEffect(() => {
    let alive = true
    ;(async () => {
      try {
        const remote = await fetchFn()
        if (!alive) return
        // ★欠けていたら null のまま。空文字や undefined を時刻として渡さない。
        setBuildTime(remote?.build_time || null)
      } catch {
        // ★オフライン等は正常系。画面は時刻抜きで出る(AC3)。
      }
    })()
    return () => { alive = false }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return buildTime
}
